// Core modules
import { Component } from '@angular/core';

// Third party modules
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'BeeFundAdmin';

  /**
   * Life cycle method
   * @param translateService Translation service
   */
  constructor(private translateService: TranslateService) {
    this.translateService.addLangs(['en', 'nl']);
    this.translateService.setDefaultLang('en');
  }
}
